/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionRunJS';

const ActionRunJSManager: ActionManagerFn<'ActionRunJS'> = (
  platform: Platform,
): ActionManager<'ActionRunJS'> => {
  return {
    ...baseActionManager(platform, 'ActionRunJS'),
    isChildAllowed: (page, item, childType) =>
      ['ActionOnResponse', 'ActionSetParam'].includes(childType),
    defaultValue,
    name: 'Run JS',
    props: {
      ...baseActionProps,
      code: {
        label: 'JS Code',
        type: 'typescript',
        compileOnChange: false,
        defaultScript: `import { parseISO } from 'date-fns';
import type { BaseFunctionProps } from 'cloudio';
import { recordId } from 'cloudio';

// this is the main function that get's invoke when executing
// this action. the return values can be accessed from
// child actions as $._.response.myResult

async function run(props: BaseFunctionProps) {
  const {appUid, pageId, platform} = props;

  // your Typescript code goes here
  // const store = platform.getStore(appUid, pageId, 'dsAlias');
  // const records = store.getRecords();

  // loop through the records and calculate some aggregate value
  // const sum = records.reduce((sum, row) => {
  //    return sum + row.someNumVal;
  // }, 0);

  // loop through the records and mark attributes as error
  // records.forEach((row) => {
  //   if (row.someAttr !== 'valid value') {
  //     store.setError('someAttr', recordId(row), 'error message');
  //   } else {
  //     store.clearError('someAttr', recordId(row));
  //   }
  // });

  // optionally return a json object
  return {myResult: 'some value', sum};
}

export default { run }
`,
      },
    },
    icon: { iconName: 'js-square', iconType: 'brands' },
    description: 'Use this action to execute Typescript code',
  };
};

export default ActionRunJSManager;
